import { TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO } from '../../../../config/tables'
import { TablaPedidoCamionesEnPlayaInsatisfechoService } from '../servicio/tabla_pedido_camiones_en_playa_insatisfecho'
import { COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO, COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT_INSATISFECHO } from './constantesPedidoCamionesEnPlaya'
import { pdfCustomToolbarGenerator } from '../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO
    })
    TablaPedidoCamionesEnPlayaInsatisfechoService.getDataPedidosCamionesEnPlayaInsatisfecho().then(callback)
    function callback (data) {
      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de Pedidos sin Finalizar',
        data,
        COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT_INSATISFECHO,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO,
          data: data,
          title: `Listado de Pedidos sin Finalizar`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: true, rowsPerPage: 50, rowsPerPageOptions: [50, 100] }
        },
        id: TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO
      })
    }
  }
}
